<template>
  <div>
    <div style="background:#151515">
      <div class="container" style="margin-bottom:0rem !important">
        <div class="row">
          <div class="py-5 book">
            <h6>Book your test drive.</h6>
            <p>The experience will never leave you, take a test drive with us.</p>
          </div>
        </div>

        <div class>
          <div class="bookcar">
            <!-- contactus form -->
            <div class="container">
              <div class="row">
                <div class="col-md-8 offset-md-2">
                  <div style="padding-bottom:20%">
                    <div class="callbackFromMsg"></div>
                    <div class="book" style="padding-top:20%">
                      <h6>Car Details</h6>
                    </div>
                    <form id="callbackForms">
                      <div class="row py-3">
                        <div class="col-md-6 form-group md-form">
                          <el-select
                            v-model="brand"
                            name="brand"
                            placeholder="Brand"
                            v-validate="'required'"
                            data-vv-as="Brand"
                            @change="onChange()"
                          >
                            <el-option
                              v-for="item in option"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>

                          <span class="text-danger">{{ errors.first('band') }}</span>
                        </div>

                        <div class="col-md-6 form-group md-form">
                          <el-select
                            class="model1"
                            name="model"
                            v-model="model"
                            placeholder="Model"
                            v-validate="'required'"
                            data-vv-as="Model"
                          >
                            <el-option
                              v-for="item in models"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </div>

                        <div class="col-md-6 form-group md-form">
                          <el-select
                            v-model="branch"
                            name="branch"
                            placeholder="Branch"
                            v-validate="'required'"
                            data-vv-as="Branch"
                          >
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>

                          <span class="text-danger">{{ errors.first('branch') }}</span>
                        </div>
                      </div>

                      <div class="book" style="padding-top:5%">
                        <h6>Your Details</h6>
                      </div>
                      <div class="row py-3">
                        <div class="col-md-6 form-group md-form">
                          <input
                            type="text"
                            name="title"
                            id="title"
                            class="form-control"
                            v-model="contactData.title"
                            placeholder="Title"
                          />
                          <span class="text-danger">{{ errors.first('title') }}</span>
                        </div>

                        <div class="col-md-6 form-group md-form">
                          <input
                            type="text"
                            name="fname"
                            id="fname"
                            class="form-control"
                            v-model="contactData.fname"
                            v-validate="'required'"
                            placeholder="First Name"
                            data-vv-as="First Name"
                          />
                          <span class="text-danger">{{ errors.first('fname') }}</span>
                        </div>

                        <div class="col-md-6 form-group md-form">
                          <input
                            type="text"
                            name="lname"
                            id="lname"
                            class="form-control"
                            v-model="contactData.lname"
                            v-validate="'required'"
                            placeholder="Last Name"
                            data-vv-as="Last Name"
                          />
                          <span class="text-danger">{{ errors.first('lname') }}</span>
                        </div>
                        <div class="col-md-6 form-group md-form">
                          <input
                            type="email"
                            name="email"
                            id="email"
                            class="form-control"
                            v-model="contactData.email"
                            v-validate="'required|email'"
                            placeholder="Email"
                            data-vv-as="Email Address"
                          />
                          <span class="text-danger">{{ errors.first('email') }}</span>
                        </div>

                        <div class="col-md-6 form-group md-form">
                          <input
                            type="text"
                            name="phone"
                            id="phone"
                            class="form-control"
                            v-model="contactData.phone"
                            v-validate="'required'"
                            placeholder="Mobile Number"
                            data-vv-as="Phone"
                          />
                          <span class="text-danger">{{ errors.first('phone') }}</span>
                        </div>
                      </div>
                      <!-- 
                      <div class="form-group md-form mb-5">
                        <textarea
                          name="message"
                          id="message"
                          cols="30"
                          rows="4"
                          style="width: 100%;"
                          class="form-control"
                          v-model="contactData.message"
                          v-validate="'required'"
                          placeholder="Your Message"
                        ></textarea>
                        <span class="text-danger">{{ errors.first('message') }}</span>
                      </div>-->

                      <div class="form-group md-form">
                        <div class>
                          <div>
                            <button
                              class="btn btn-success"
                              v-on:click.prevent="contactFormSubmitFxn($event)"
                            >
                              <span>Book Now</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div class="col-md-5 offset-md-1 py-4"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>

<script>
// import TopHeroBanner from "@/components/TopHeroBanner1.vue";
import axios from "axios";
import CoreValues from "../components/Core.vue";
export default {
  components: { core: CoreValues },
  name: "book",
  data() {
    return {
      contactData: { title: "", fname: "", lname: "", email: "", phone: "" },
      title: "Book",
      options: [
        {
          value: "Accra",
          label: "Accra"
        },
        {
          value: "Tema",
          label: "Tema"
        },
        {
          value: "Kumasi",
          label: "Kumasi"
        }
      ],
      branch: "",

      option: [
        {
          value: "Peugeot",
          label: "Peugeot"
        },
        {
          value: "Citroën",
          label: "Citroën"
        }
      ],
      brand: "",
      models: [],
      model: ""
    };
    console.log(this.option.value);
  },
  methods: {
    onChange() {
      switch (this.brand) {
        case "Peugeot":
          console.log("new p" + this.brand);

          this.models = [
            {
              value: "301 saloon",
              label: "301 saloon"
            },
            {
              value: "508 saloon",
              label: "508 saloon"
            },
            {
              value: "2008 SUV",
              label: "2008 SUV"
            },
            {
              value: "3008 SUV",
              label: "3008 SUV"
            },
            {
              value: "5008 SUV",
              label: "5008 SUV"
            },
            {
              value: "301 Saloon",
              label: "301 Saloon"
            },
            {
              value: "Landtrek 4x4 PickUp",
              label: "Landtrek 4x4 PickUp"
            }
          ];
          break;
        case "Mercedes":
          console.log("new m" + this.brand);
          $(".model1").css("display", "none");
          $(".model").css("display", "block");

          break;
        case "Citroën":
          console.log("new c" + this.brand);
          this.models = [
            {
              value: "C4 Cactus",
              label: "C4 Cactus"
            },
            {
              value: "C5 Aircross",
              label: "C5 Aircross"
            },
            {
              value: "Berlingo Van ",
              label: "Berlingo Van "
            },
            {
              value: "Berlingo Passanger ",
              label: "Berlingo Passanger "
            },
            {
              value: "Jumper Van",
              label: "Jumper Van "
            },
            {
              value: "Jumper Passenger",
              label: "Jumper Passenger"
            }
          ];
          break;
      }
    },
    check() {
      // console.log("hello world ")
      if (this.brand.value == "Peugeot") {
        console.log("hello world ");
        this.models = [
          {
            value: "301 Saloon",
            label: "301 Saloon"
          },
          {
            value: "3008 SUV",
            label: "3008 SUV"
          },
          {
            value: "5008 SUV",
            label: "5008 SUV"
          },
          {
            value: "KP0 Pick Up",
            label: "KP0 Pick Up"
          }
        ];
      } else {
        this.models = [
          {
            value: "Berlingo Van",
            label: "Berlingo Van"
          },
          {
            value: "Berlingo Passenger",
            label: "Berlingo Passenger"
          },
          {
            value: "Jumper Van",
            label: "Jumper Van"
          },
          {
            value: "Jumper Passenger",
            label: "Jumper Passenger"
          },
          {
            value: "C4 Cactus",
            label: "C4 Cactus"
          },
          {
            value: "C5 Aircross",
            label: "C5 Aircross"
          }
        ];
      }
    },
    contactFormSubmitFxn(e) {
      var btn = e.currentTarget;
      var sve = document.querySelector(".s-v-e");
      if (sve) sve.remove();

      this.$validator.validateAll().then(result => {
        if (result) {
          var contactFormData = {
            title: this.contactData.title,
            fname: this.contactData.fname,
            lname: this.contactData.lname,
            email: this.contactData.email,
            phone: this.contactData.phone,
            branch: this.branch,
            brand: this.brand,
            model: this.model
          };

          contactFormData = JSON.stringify(contactFormData);
        
          axios.interceptors.request.use(function(arg) {
            btn.innerHtml = '<i class="fa fa-spinner fa-spin fa-fw"></i>';
            return arg;
          });

          axios
            .post(APIURL + "booking", contactFormData)
            .then(response => {
              var res = response.data;
              btn.innerHTML = "Submit";
              if (res.status === true) {
                if(this.model== "Landtrek 4x4 PickUp"){
                 
                 javascript:window.adf&&adf.ClickTrack(this,2867926,'Ghana Silverstar Book a test drive Landtrek',{});		
               }
                var responseMsg = document.querySelector(".callbackFromMsg");
                var html = `<div class="alert alert-success alert-dismissible fade show" role="alert">
                                                ${res.msg}
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>`;
                responseMsg.classList.add("my-3");
                responseMsg.innerHTML = html;

                this.contactData.title = "";
                this.contactData.fname = "";
                this.contactData.lname = "";
                this.contactData.email = "";
                this.contactData.phone = "";
                this.branch = "";
                this.brand = "";
                this.model = "";

                this.$validator.reset();
              } else {
                if (res.status === "validation_errors") {
                  res.errors.forEach((k, v) => {
                    document.querySelector(`#${k}`).appendChild(v);
                  });
                } else {
                  var responseMsg = document.querySelector(".callbackFromMsg");
                  var html = `<div class="alert alert-danger alert-dismissible fade show" role="alert">
                                                ${res.msg}
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>`;
                  responseMsg.classList.add("my-3");
                  responseMsg.innerHTML = html;

                  this.contactData.title = "";
                  this.contactData.fname = "";
                  this.contactData.lname = "";
                  this.contactData.email = "";
                  this.contactData.phone = "";
                  this.branch = "";
                  this.brand = "";
                  this.model = "";

                  this.$validator.reset();
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  },
  metaInfo() {
    return {
      title: "Book"
    };
  },
  created() {
    this.check();
  }, mounted(){

  }
};
</script>
